import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";
import { ServiceCompany } from "../../Model/ServiceCompany/ServiceCompany";

export async function createServiceCompanyService(data) {
    let response = await getAPIResponse("/v1/service-company", data, "POST");
    if (response === null) {
        return null;
    }
    return ServiceCompany.createFormResponseData(response);
}
